<template>

    <v-layout wrap>
        <TableReporting
            @pagination="pagination = $event"
            :pagination="pagination"
            :reports="reports"
            :doneFetching="doneFetching"
            styleTable="border: 1px solid rgba(0,0,0,.12);border-radius: 4px;margin: 10px;"
        ></TableReporting>

        <v-speed-dial fixed v-model="fab" bottom :right="$vuetify.breakpoint.mdAndUp" transition="scale-transition" :direction="$vuetify.breakpoint.mdAndUp ? 'left' : 'top'">
            <template v-slot:activator>
                <v-btn v-model="fab" color="accent" dark fab>
                    <v-icon>mdi-briefcase-upload</v-icon>
                    <v-icon>close</v-icon>
                </v-btn>
            </template>
            <v-btn class="text-xs-left" v-for="(tab, key) in fabButtons" :key="key" dark round :color="tab.color" @click="dialog = true" style>{{ tab.name }}</v-btn>
        </v-speed-dial>
        <v-dialog v-model="dialog" persistent min-height="500px" max-width="700px" :fullscreen="$vuetify.breakpoint.smAndDown">
            <v-card>
                <v-layout justify-center>
                    <v-card-title class="headline">
                        <strong class="headline">Relatório de disparos</strong>
                    </v-card-title>
                </v-layout>
                <v-divider></v-divider>
                <v-layout
                        :style="$vuetify.breakpoint.smAndDown ? 'min-height: 70vh' : 'min-height: 45vh'"
                    column>
                    <v-flex class="ma-2" xs12 style="height:0px;">
                        <v-md-date-range-picker
                            style="margin: 0px!important"
                            :opens="'left'"
                            @change="handleChange"
                            :presets="presets"
                            :start-date="this.range.start"
                            :end-date="this.range.end"
                        ></v-md-date-range-picker>
                    </v-flex>
                    <v-layout row wrap class="px-2 pt-0" style="height:0px;">
                        <v-flex class="pr-2" xs12 md6>
                            <SelectCreditors
                                :selected="selectedCreditors"
                                @selectedCreditors="changeSelectCreditors($event)"
                            ></SelectCreditors>
                        </v-flex>
                        <v-flex xs12 md6 style="height:0px;">
                            <v-select
                                v-model="selectedPuplic"
                                success
                                clearable
                                :items="publics"
                                multiple
                                :selected="selectedPuplic == 0 ? undefined : selectedPuplic"
                                label="Público"
                                flat
                                item-text="name"
                                item-value="value"
                                box
                                class="text-details-none"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <span v-if="index === 0" style="padding-right: 5px">{{ item.name }}</span>
                                    <span
                                        v-if="index === 1"
                                        class="grey--text caption"
                                    >(+{{ selectedPuplic.length -1 + (selectedPuplic.length == 2 ? " outro)" : " outros)")}}</span>
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="mt-2 pr-2">
                            <v-select
                                v-model="selectedApproachTypes"
                                success
                                clearable
                                :items="approachesTypes"
                                multiple
                                flat
                                box
                                class="text-details-none"
                                label="Tipo de abordagem"
                            >
                                <template v-slot:selection="{ item, index }">
                                    <!-- <span style="padding-right: 5px;" v-if="index === 0">{{ item.name }}</span> -->
                                    <span v-if="index == 0">{{ index === 0 ? item : ", " + item}}</span>
                                    <span
                                        v-if="index === 1"
                                        style="padding-left: 5px"
                                        class="grey--text caption"
                                        >(+{{selectedApproachTypes.length - 1 +
                                            (selectedApproachTypes.length == 2 ? " outro)" : " outros)")}}</span
                                    >
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="mt-2" style="height:0px;">
                            <v-select v-model="statusSelected"
                            :items="status" item-text="text" item-value="id" 
                            box flat success small-chips label="Status" multiple clearable>
                                <template v-slot:selection="{item,index}">
                                    <span v-if="index <= 0">{{ item.text }}</span>
                                    <span v-if="index === 1" style="padding-left: 5px" class="grey--text caption">
                                        (+{{ statusSelected.length -1 + (statusSelected.length == 2 ? " outro)" : " outros)")}}
                                    </span>
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex xs12 md6 class="mt-2 pr-2">
                            <v-select v-model="onlyAutoSelected"
                            :items="onlyAuto" item-text="text" item-value="id" 
                            box flat success small-chips label="Tipo Disparo" multiple clearable>
                                <template v-slot:selection="{item,index}">
                                    <span v-if="index <= 0">{{ item.text }}</span>
                                    <span v-if="index === 1" style="padding-left: 5px" class="grey--text caption">
                                        (+{{ onlyAutoSelected.length -1 + (onlyAutoSelected.length == 2 ? " outro)" : " outros)")}}
                                    </span>
                                </template>
                            </v-select>
                        </v-flex>
                        <v-flex xs12 sm6 class="mt-2">
                            <v-select
                            box
                            flat
                            success
                            multiple
                            clearable
                            hide-details
                            label="Gateway"
                            item-value="code"
                            item-text="name"
                            :items="gateways"
                            v-model="selectedGateway"
                            >
                            <template v-slot:selection="{ item, index }">
                                <span v-if="index === 0" style="padding-right: 5px">{{ item.name }}</span>
                                <span v-if="index === 1" style="padding-left: 5px" class="grey--text caption"
                                >(+{{
                                    selectedGateway.length -
                                    1 +
                                    (selectedGateway.length == 2 ? " outro)" : " outros)")
                                }}</span
                                >
                            </template>
                            </v-select>
                        </v-flex>
                    </v-layout>
                    <v-spacer></v-spacer>
                    <v-spacer></v-spacer>
                </v-layout>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-layout column>
                        <v-layout row wrap justify-end align-center>
                            <!-- <v-flex class="text-xs-right pr-1 pb-1">
                                <p class="subheading font-weight-bold">{{notifications | numeral('0,0')}} {{notifications == 1 ? 'Linha' : 'Linhas'}}</p>
                            </v-flex> -->
                        </v-layout>
                        <v-layout row wrap justify-end align-center>
                            <!-- <v-flex v-if="notifications > 800000" class="text-xs-right mr-2">
                                <p class="body-1 red--text">Não é possivel estrair relatórios acima de 800 mil linhas</p>
                            
                            </v-flex> -->
                            <v-btn color="secondary" flat  @click="dialog = false">cancelar</v-btn>
                            <v-btn color="secondary" flat   @click="extractReport()">Extrair relatório</v-btn>
                        </v-layout>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-layout>
</template>

<script>
import reportingService from "@/services/reporting/reporting";
import TableReporting from "@/components/reporting/TableReporting";
import enviroment from "@/enviroment";
import store from "@/store";
import strategyNotificationService from "@/services/notification-history";
import moment from "moment";
import strategyPublic from "@/utils/strategy-public";
import SelectCreditors from "@/components/creditor/SelectCreditors";
import gatewaysService from "@/services/gateways";


export default {
    components: {
        TableReporting,
        SelectCreditors
    },
    watch: {
        pagination: {
            async handler() {
                if (this.doneFetching) {
                    this.addfilters();
                    await this.searchReports();
                }
            },
            deep: true
        }
    },
    async created() {
        this.getGateway();
        this.publics = strategyPublic.strategyPublic;
        await this.searchReports();
        
        this.query = this.$route.query;
        if (this.query && Object.keys(this.query).length == 0) {
            this.query = store.getters.getReportsFilters;
        }
        if (this.query) {
            if (this.query.sortBy) this.pagination.sortBy = this.query.sortBy;
            if (this.query.descending)
                this.pagination.descending = this.query.descending;
            if (this.query.rowsPerPage)
                this.pagination.rowsPerPage = this.query.rowsPerPage;
            if (this.query.page) this.pagination.page = this.query.page;
            if (this.query.descending) {
                if (typeof this.query.descending === "string") {
                    this.pagination.descending = JSON.parse(
                        this.query.descending.toLowerCase()
                    );
                } else {
                    this.pagination.descending = this.query.descending;
                }
            }
        }
        this.doneFetching = true;
    },
    data() {
        return {
            doneFetching: false,
            gateways: [],
            selectedGateway: [],
            reports: {},
            publics:[],
            notifications:null,
            selectedApproachTypes:[],
            approachesTypes: [
                "SMS",
                "PUSH",
                "EMAIL",
                "CALL_CELLPHONE",
                "CALL_PHONE",
                "WHATSAPP"
            ],
            fabButtons:[
                {
                    'name':'Disparos',
                    'color':'indigo',
                }
            ],
            status:[
                {
                    text: "Acessados",
                    id: "accessed",
                },
                {
                    text: "Localizados",
                    id: "localized",
                },
                {
                    text: "Propostas confirmadas",
                    id: "proposalConfirmed",
                },
                {
                    text: "Propostas Aceitas",
                    id: "proposalAgreed",
                }
                
            ],
            onlyAuto:[
                {
                    text: "Automáticos",
                    id: 'true',
                },
                {
                    text: "Manual",
                    id: 'false',
                },                
            ],
            statusSelected:[],
            onlyAutoSelected: [],
            fab: false,
            range: {
                start: moment().subtract(0, "day").format("YYYY-MM-DD"),
                end: moment().subtract(0, "day").format("YYYY-MM-DD"),
            },
            query: {},
            selectedCreditors:[],
            selectedPuplic:[],
            dialog:false,
            pagination: {
                descending: true,
                page: 1,
                rowsPerPage: 25,
                sortBy: "updated_at",
                totalItems: 0,
                rowsPerPageItems: [10, 25, 50, 100]
            },
            presets: [
                {
                    label: "Hoje",
                    range: this.getRange(0, 0),
                },
                {
                    label: "Ontem",
                    range: this.getRange(1, 1),
                },
                {
                    label: "Últimos 7 dias",
                    range: this.getRange(6, 0),
                },
            ],
        };
    },
    fetchData(){

    },
    methods: {
        async extractReport() {
            await reportingService
            .generateReport('MANY_FIRING', [], this.selectedCreditors,
                this.selectedPuplic, 
                this.selectedApproachTypes,
                this.statusSelected,
                this.onlyAutoSelected,
                this.range.start, this.range.end,
                this.selectedGateway)
                .then((resp) => {
                    this.$store.commit(
                        "showSnackbar",
                        "Relatório gerado com sucesso."
                    );
                    this.dialog = false
                    this.searchReports()
                })
                .catch((err) => {
                    console.error(err);
                    this.$store.commit(
                        "showSnackbar",
                        "Houve um erro ao gerar o relatório."
                    );
                });
        },
        changeSelectCreditors(event) {
            this.selectedCreditors = event;
            // this.getNotificationsCount()
        },
        handleChange(values) {
            this.range.start = moment(values[0]._d).format("YYYY-MM-DD");
            this.range.end = moment(values[1]._d).format("YYYY-MM-DD");
            // this.getNotificationsCount()
        },
        getRange(startOffset = 0, endOffset = 0, period = "day") {
            return [
                moment().subtract(startOffset, period).startOf(period),
                moment().subtract(endOffset, period).endOf(period),
            ];
        },
        async getNotificationsCount() {
            let params = {};
            if (this.range.start && this.range.end) {
                params["start_date"] = this.range.start;
                params["end_date"] = this.range.end;
            }
            if (this.selectedPuplic.length)
                params["strategy_public"] = this.selectedPuplic
                    .map((sp) => sp)
                    .join(",");
            if (this.selectedCreditors.length)
                params["creditors_ids"] = this.selectedCreditors
                    .map((id) => id)
                    .join(",");
            if (this.selectedApproachTypes.length) {
                params['approach_types'] = this.selectedApproachTypes
                    .map((sp) => sp)
                    .join(",");
            }
            await strategyNotificationService
                .fetchNotificationCount(params)
                .then((res) => {
                    this.notifications = res['total']['notifications'] || 0;
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        async searchReports() {
            reportingService
                .getReports(this.pagination)
                .then(files => (this.reports = files));
        },
        getGateway() {
            gatewaysService.gateways().then((resp) => {
                resp.objects.forEach((item) => {
                    this.gateways.push({
                        name: item.name,
                        code: item.code,
                    });
                });
            });
        },
        addfilters() {
            this.query = {};
            this.query.rowsPerPage = this.pagination.rowsPerPage;
            this.query.page = this.pagination.page;
            if (this.pagination.descending)
                this.query.descending = this.pagination.descending;
            if (this.pagination.sortBy)
                this.query.sortBy = this.pagination.sortBy;
            else this.query.sortBy = 0;
            this.$store.commit("setReportsFilters", this.query);
            if (this.$route.path == "/reporting-history") {
                this.$router.replace({
                    name: "Histórico de relatórios",
                    query: this.query
                });
            }
        }
    }
};
</script>

<style>
</style>